export { default } from './CustomerDetail'


// WEBPACK FOOTER //
// ./src/scenes/Administration/Customer/CustomerDetail/index.js